/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { type Signal, signal } from '@preact/signals-react'
import { type FormInstance } from 'antd/lib'

import { type TApplication } from '@/interfaces'
import {
  type TEntityInfo,
  type TFileViewer,
  type TFormState,
  type TEntityForm,
  type EFormFieldTypes,
} from '@/interfaces/form'

const currentForm: Signal<TEntityInfo[]> = signal([])

const currentEntity: Signal<TEntityInfo | null> = signal(null)

const fileViewer: Signal<TFileViewer> = signal({
  fileBase64String: null,
  isImage: false,
  isPdf: false,
  openModal: false,
})

const entityForm: Signal<TEntityForm> = signal({
  form: [],
  mode: null,
  openDrawer: false,
  values: {},
})

const showForm: Signal<boolean> = signal(false)

const currentFormInstance: Signal<FormInstance | null> = signal(null)

const currentNewApplicationId: Signal<number> = signal(1)

const hasRequiredFieldsEmpty: Signal<boolean> = signal(false)

const currentEntityDateFields: Signal<
  Array<{ name: string; type: EFormFieldTypes }>
> = signal([])

const currentFormValues: Signal<TApplication> = signal({})

export const FormState: TFormState = {
  currentEntity,
  currentEntityDateFields,
  currentForm,
  currentFormInstance,
  currentFormValues,
  currentNewApplicationId,
  entityForm,
  fileViewer,
  hasRequiredFieldsEmpty,
  showForm,
}
